import { CarmValidatorsList } from '@carm/_utils/error-handler/validations/carm-validators';
import { EditField3Ce } from './edit-field-3ce.model';
import { EditFieldBase } from './edit-field-base.model';
import { EditFieldDate } from './edit-field-date.model';
import { EditFieldDropdown } from './edit-field-dropdown.model';
import { EditFieldMetadataTypeEnum } from './edit-field-metadata-type.enum.model';
import { EditFieldNumeric } from './edit-field-numeric.model';
import { EditFieldTextbox } from './edit-field-textbox.model';
import { EditFieldsEnum } from './edit-field.model';

export const goodEditFields: EditFieldBase<any>[] = [
    new EditFieldTextbox({
        key: EditFieldsEnum.PreviousWarehouseLineNumber,
        i18nText: 'concepts.declarations.massAdjustments.level.good.previous_warehouse_line',
        required: true,
        order: 1
    }),
    new EditFieldDate({
        key: EditFieldsEnum.DirectShipmentDate,
        i18nText: 'concepts.declarations.massAdjustments.level.good.shipment_date',
        required: true,
        order: 2
    }),
    new EditField3Ce({
        key: EditFieldsEnum.ClassificationNumber,
        i18nText: 'concepts.declarations.massAdjustments.level.good.classification_number',
        required: true,
        validators: [CarmValidatorsList.required.validateFn(), CarmValidatorsList.classNumber.validateFn()],
        order: 3
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.Description,
        i18nText: 'concepts.declarations.massAdjustments.level.good.description',
        required: true,
        order: 4
    }),
    new EditFieldNumeric({
        key: EditFieldsEnum.Quantity,
        i18nText: 'concepts.declarations.massAdjustments.level.good.quantity',
        required: true,
        order: 5
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.UnitOfMeasure,
        i18nText: 'concepts.declarations.massAdjustments.level.good.unit_measure',
        metadataType: EditFieldMetadataTypeEnum.UnitOfMeasure,
        required: true,
        order: 6
    }),
    new EditFieldNumeric({
        key: EditFieldsEnum.ValueCurrencyConversion,
        i18nText: 'concepts.declarations.massAdjustments.level.good.currency_conversion',
        required: true,
        order: 7
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.CurrencyCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.currency_code',
        metadataType: EditFieldMetadataTypeEnum.CurrencyCode,
        required: true,
        order: 8
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.CountryOfOrigin,
        i18nText: 'concepts.declarations.massAdjustments.level.good.country_origin',
        metadataType: EditFieldMetadataTypeEnum.CountryList,
        required: true,
        order: 9
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.PlaceOfExport,
        i18nText: 'concepts.declarations.massAdjustments.level.good.place_export',
        metadataType: EditFieldMetadataTypeEnum.CountryList,
        required: true,
        order: 10
    }),
    new EditFieldNumeric({
        key: EditFieldsEnum.PstHstQst,
        i18nText: 'concepts.declarations.massAdjustments.level.good.pst_hst_qst',
        required: true,
        order: 11
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.DestinationProvince,
        i18nText: 'concepts.declarations.massAdjustments.level.good.destination_province',
        metadataType: EditFieldMetadataTypeEnum.DestinationProvince,
        required: true,
        order: 12
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.TariffTreatment,
        i18nText: 'concepts.declarations.massAdjustments.level.good.tariff_treatment',
        metadataType: EditFieldMetadataTypeEnum.TariffTreatment,
        required: true,
        order: 12
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.TariffCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.tariff_code',
        metadataType: EditFieldMetadataTypeEnum.TariffCode,
        required: true,
        order: 13
    }),
    new EditFieldNumeric({
        key: EditFieldsEnum.ValueDutyCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.value_duty_code',
        required: true,
        order: 14
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.RulingNumber,
        i18nText: 'concepts.declarations.massAdjustments.level.good.ruling_number',
        required: true,
        order: 15
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.OrderInCouncil,
        i18nText: 'concepts.declarations.massAdjustments.level.good.oic',
        required: true,
        order: 16
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.DutyReliefLicence,
        i18nText: 'concepts.declarations.massAdjustments.level.good.duty_relief_licence',
        required: true,
        order: 17
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.SpecialAuthorityPermit,
        i18nText: 'concepts.declarations.massAdjustments.level.good.special_authority_permit',
        required: true,
        order: 18
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.CustomsDuty,
        i18nText: 'concepts.declarations.massAdjustments.level.good.customs_duty',
        required: true,
        order: 18
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.ExciseDuty,
        i18nText: 'concepts.declarations.massAdjustments.level.good.excise_duty',
        required: true,
        order: 19
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.TimeLimitType,
        i18nText: 'concepts.declarations.massAdjustments.level.good.time_limit_type',
        metadataType: EditFieldMetadataTypeEnum.TimeLimitType,
        required: true,
        order: 16
    }),
    new EditFieldDate({
        key: EditFieldsEnum.TimeLimitFrom,
        i18nText: 'concepts.declarations.massAdjustments.level.good.time_limit_from',
        required: true,
        order: 17
    }),
    new EditFieldDate({
        key: EditFieldsEnum.TimeLimitTo,
        i18nText: 'concepts.declarations.massAdjustments.level.good.time_limit_to',
        required: true,
        order: 18
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.ExciseTaxCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.excise_tax_code',
        metadataType: EditFieldMetadataTypeEnum.ExciseTaxCode,
        required: true,
        order: 19
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.ExciseTaxAmount,
        i18nText: 'concepts.declarations.massAdjustments.level.good.excise_tax_amount',
        required: true,
        order: 20
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.ProvAlcoholTaxAmount,
        i18nText: 'concepts.declarations.massAdjustments.level.good.prov_alcohol_tax_amount',
        required: true,
        order: 21
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.AlcoholPercent,
        i18nText: 'concepts.declarations.massAdjustments.level.good.alcohol_percent',
        required: true,
        order: 22
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.ProvTabaccoTaxAmount,
        i18nText: 'concepts.declarations.massAdjustments.level.good.provincial_tobacco_tax_amount',
        required: true,
        order: 23
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.ProvCannabisTaxAmount,
        i18nText: 'concepts.declarations.massAdjustments.level.good.prov_cannabis_tax_amount',
        required: true,
        order: 23
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.GSTCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.GST_code',
        metadataType: EditFieldMetadataTypeEnum.GSTCode,
        required: true,
        order: 24
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.GSTAmount,
        i18nText: 'concepts.declarations.massAdjustments.level.good.GST_amount',
        required: true,
        order: 25
    }),
];
